import React from 'react';

const ExternalLink = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 15 15" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="ExternalLink_a"
        d="M1233.33 466.33h-11.66v-11.66h5.83V453h-5.83c-.93 0-1.67.75-1.67 1.67v11.66c0 .92.74 1.67 1.67 1.67h11.66c.92 0 1.67-.75 1.67-1.67v-5.83h-1.67zm-4.16-13.33v1.67h2.99l-8.2 8.19 1.18 1.17 8.2-8.19v3h1.66V453z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#ExternalLink_a" transform="translate(-1220 -453)" />
  </svg>
);

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/common/icons/ExternalLink.js